import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { FunnelTemplate } from '@models/recruiting/funnel-template.model';
import { BadgeDisplay } from '@table/interfaces/badge-display.interface';

export class EmailAutomation extends Column {
    title = 'applicant-tracker.emailAutomation';
    property = 'hasEmailAutomation';
    sortField = 'hasEmailAutomation';
    sortable = false;
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(funnelTemplate: FunnelTemplate): BadgeDisplay | undefined {
        if (!funnelTemplate.hasEmailAutomation) {
            return;
        }

        return {
            type: 'default',
            label: 'applicant-tracker.configured',
        };
    }

    getCellText(): null {
        return null;
    }
}
